import styled from "styled-components";

export const HeaderWrapper = styled.div<{ placeBetSuccess: boolean }>`
  display: flex;
  flex-direction: ${({ placeBetSuccess }) =>
    placeBetSuccess ? "row" : "column"};
  justify-content: center;
  align-items: center;
`;
